
const getters = {
  getTest1(state) {
    return state.test1
  },
  getThemeBar(state) {
    return state.themeBar
  },
  getUploading(state) {
    return state.uploading
  },
  getProgressMsg(state) {
    return state.progressmsg
  },
  getPercentageUploaded(state) {
    return state.percentageUploaded
  },
  getSplitButtonLocationReset(state) {
    return state.resetSplitButtonLocation
  },
  getErrorMessages(state) {
    return state.errorsMessages
  },
  reLoginDialog(state) {
    return state.reLoginDialog
  },
  getLastPage(state) {
    return state.lastPage
  },
  getLastFromPage(state) {
    return state.lastFromPage
  },
  getLastPathName(state) {
    return state.lastPathName
  },
  getLastEPs(state) {
    return state.lastEPs
  },
  getLastErrorEP(state) {
    return state.lastErrorEP
  },
  getEpError(state) {
    return state.epError
  },
  getEpPayload(state) {
    return state.epPayload
  },
  getErrorCode(state) {
    return state.errorCode
  },
  getEpDatetime(state) {
    return state.epDatetime
  },
  getStaticMenuDesktopInactive(state) {
    return state.staticMenuDesktopInactive
  },
  getActiveThemeColor(state) {
    return state.activeThemeColor
  },
  getAppWindowWidth(state) {
    return state.appWindowWidth
  },
  getAppWindowHeight(state) {
    return state.appWindowHeight
  },
  getVideosData(state) {
    return state.videosData
  },
  getRequestingVideos(state) {
    return state.requestingVideos
  }
}

export default getters